import React, { useState } from 'react';
import PropTypes from 'prop-types';
import callToActionData from 'core/data/call-to-action-data';
import { useInitialFetch } from 'core/context/initialFetchContext';
import BaseModal from 'components/common/modal/BaseModal';
import FormContact from 'components/artectum/common/contact-form-artectum';
import { Modal, Button } from 'react-bootstrap';


const CallToAction = ({ className }) => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const publicUrl = process.env.PUBLIC_URL || '';
    const { subtitle, title, phone, buttonText, contactText, images } = callToActionData;
    const { storeInformation } = useInitialFetch();
    const message = "Hola, estoy interesado en obtener más información."; // New message
    // const whatsappUrl = `https://wa.me/${storeInformation?.whatsapp}?text=${encodeURIComponent(message)}`; // Updated URL

    const closeModal = () => {
        setModalIsOpen(false);
    };

    return (

        <>
        <div
            className={`ltn__call-to-action-area ltn__call-to-action-4 pt-90 pb-120 ${className}`}
            style={{ backgroundImage: `url(${publicUrl + images.background})` }}
        >
            <div className="container text-center">
                <div className="call-to-action-inner call-to-action-inner-4">
                    <div className="section-title-area ltn__section-title-2">
                        <h6 className="section-subtitle ltn__secondary-color" style={{ color: '#333' }}>{subtitle}</h6>
                        <h1 className="section-title" style={{ color: '#333' }}>{title}</h1>
                    </div>
                    <div className="btn-wrapper d-flex justify-content-center gap-3 mt-3">
                        {/* <a href={`tel:${storeInformation?.phone_number}`} className="theme-btn-1 btn btn-effect-1">
                            LLAMANOS AHORA
                        </a> */}
                        <button
                            onClick={() => setIsFormOpen(true)}
                            className="btn theme-btn-4"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {contactText}
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <BaseModal
            show={isFormOpen}
            title="Obten más información de este producto"
            handleClose={() => setIsFormOpen(false)}
            handleSave={() => setIsFormOpen(false)}
            size="lg"
        >
            <FormContact fromWsp={true} message={message} wspUrl={`https://wa.me/${storeInformation?.whatsapp}`} handleCloseParentModal={() => setIsFormOpen(false)} setModalIsOpen={setModalIsOpen} />
        </BaseModal>

        <Modal show={modalIsOpen} size="lg" onHide={closeModal}>
            <Modal.Header className="p-4 pb-0" closeButton>
                <Modal.Title>
                    <i className="fas fa-check-circle text-success me-2"></i>
                    Formulario enviado con éxito
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <div id='product-pro-forma'>
                    <p>Gracias por contactarnos. Nos pondremos en contacto con usted pronto.</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
};

CallToAction.propTypes = {
    className: PropTypes.string,
};

CallToAction.defaultProps = {
    className: 'section-bg-1',
};

export default CallToAction;